module.exports = __webpack_public_path__ + "media/Schnarchen.71678810.mp3";